module.exports = __webpack_public_path__ + "static/media/portoEduc_Bn_Sala_Virtual_Agenda.b6801e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portoEduc_Bn_Sala_Virtual_Agenda.jpg
// module id = 1787
// module chunks = 0